import SpriteSymbol from "../../../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "gw-subtopic",
  "use": "gw-subtopic-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" id=\"gw-subtopic\"><path fill=\"none\" d=\"M0 0h24v24H0Z\" /><path d=\"M7 2c.9 0 1.91 1.04 2 2v15.94c0 .95-.92 1.95-1.87 2.04H3c-.97 0-1.93-.94-2.01-1.92l-.01-.15V4.01c0-.98.91-1.96 1.86-2.05l4.13-.01Zm-.5 2h-3c-.28 0-.5.37-.5.84v14.31c0 .46.22.84.5.84h3c.27 0 .5-.38.5-.85V4.82c0-.47-.23-.85-.5-.85Zm14.52 4H13c-1.02 0-2.02 1-2.02 2v4c0 .98 1 1.99 2.01 1.99H21c.97-.25 1.97-1 1.97-2V9.98c0-.99-1-2.01-1.98-2.01Z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol